module.exports = __webpack_public_path__ + "static/media/urban-machina.18cd2324.jpg";